export const fleetVehicles = [
  {
    id: "veh-001",
    nombre: "Camión de mudanza 20 m³",
    categoria: "camiones",
    tipo: "Camión de mudanza",
    capacidad: "20 m³ · 5.500 kg",
    capacidadGrupo: "alta",
    descripcion:
      "Unidad cerrada con rampa y equipo de sujeción, ideal para mudanzas completas de viviendas y oficinas.",
    caracteristicas: ["Rampa hidráulica", "Cierre de seguridad", "Cobertores incluidos", "2 ayudantes"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Large%20white%20moving%20truck%20with%20open%20rear%20ramp%20and%20neatly%20stacked%20furniture%20inside%20a%20clean%20bright%20warehouse%20bay%2C%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20editorial%20photography%2C%20sharp%20detail&width=900&height=640&seq=axonia-veh-001&orientation=landscape",
    estado: "disponible",
    zona: "Zona metropolitana y alrededores",
    servicio: "Mudanzas",
    orden: 1,
    activo: true,
  },
  {
    id: "veh-002",
    nombre: "Camión de carga pesada",
    categoria: "camiones",
    tipo: "Camión de carga",
    capacidad: "32 t · 60 m³",
    capacidadGrupo: "alta",
    descripcion:
      "Camión de gran tonelaje para cargas industriales, materiales y traslados de alto volumen.",
    caracteristicas: ["Carga pesada", "Plataforma amplia", "Amarres certificados", "Cobertura nacional"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Heavy%20duty%20white%20cargo%20truck%20with%20large%20trailer%20loaded%20with%20industrial%20materials%20in%20a%20clean%20logistics%20yard%2C%20minimal%20bright%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20steel%20grey%20tones%2C%20professional%20industrial%20photography&width=900&height=640&seq=axonia-veh-002&orientation=landscape",
    estado: "disponible",
    zona: "Cobertura nacional",
    servicio: "Acarreo",
    orden: 2,
    activo: true,
  },
  {
    id: "veh-003",
    nombre: "Camión de reparto urbano",
    categoria: "camiones",
    tipo: "Camión de reparto",
    capacidad: "3.5 t · 18 m³",
    capacidadGrupo: "media",
    descripcion:
      "Unidad ágil para distribución urbana y entregas de última milla en calles estrechas.",
    caracteristicas: ["Acceso a zonas restringidas", "Carga lateral", "Bajo consumo", "Rastreo GPS"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Compact%20white%20urban%20delivery%20truck%20parked%20on%20a%20clean%20city%20street%20with%20parcel%20trolleys%2C%20minimal%20urban%20background%2C%20soft%20morning%20light%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20editorial%20photography%2C%20crisp%20detail&width=900&height=640&seq=axonia-veh-003&orientation=landscape",
    estado: "disponible",
    zona: "Zona urbana",
    servicio: "Distribución",
    orden: 3,
    activo: true,
  },
  {
    id: "veh-004",
    nombre: "Furgoneta de carga grande",
    categoria: "vans",
    tipo: "Furgoneta",
    capacidad: "12 m³ · 1.200 kg",
    capacidadGrupo: "media",
    descripcion:
      "Furgoneta espaciosa para mudanzas pequeñas, traslados de equipos y entregas rápidas.",
    caracteristicas: ["Puerta lateral", "Carga ligera", "Estacionamiento fácil", "Ideal ciudad"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Large%20white%20cargo%20van%20with%20open%20rear%20doors%20and%20neatly%20arranged%20boxes%20inside%2C%20clean%20minimal%20studio%20background%2C%20soft%20natural%20daylight%2C%20cool%20blue%20and%20white%20palette%2C%20professional%20editorial%20photography%2C%20sharp%20detail&width=900&height=640&seq=axonia-veh-004&orientation=landscape",
    estado: "disponible",
    zona: "Zona metropolitana",
    servicio: "Mudanzas",
    orden: 4,
    activo: true,
  },
  {
    id: "veh-005",
    nombre: "Van para repartidores",
    categoria: "vans",
    tipo: "Van de reparto",
    capacidad: "8 m³ · 900 kg",
    capacidadGrupo: "baja",
    descripcion:
      "Van compacta y eficiente para reparto diario, mensajería y distribución de última milla.",
    caracteristicas: ["Bajo consumo", "Rastreo GPS", "Entrega rápida", "Fácil de operar"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Compact%20white%20delivery%20van%20parked%20in%20a%20clean%20minimal%20urban%20setting%20with%20parcel%20boxes%20beside%20it%2C%20bright%20neutral%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20editorial%20photography&width=900&height=640&seq=axonia-veh-005&orientation=landscape",
    estado: "reservado",
    zona: "Zona urbana",
    servicio: "Reparto",
    orden: 5,
    activo: true,
  },
  {
    id: "veh-006",
    nombre: "Van de transporte de personal",
    categoria: "vans",
    tipo: "Van de pasajeros",
    capacidad: "14 pasajeros",
    capacidadGrupo: "media",
    descripcion:
      "Van climatizada para traslado de personal, equipos de trabajo y grupos pequeños.",
    caracteristicas: ["Aire acondicionado", "Asientos reclinables", "Seguro para equipaje", "Conductor profesional"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Modern%20white%20passenger%20van%20with%20tinted%20windows%20parked%20outside%20a%20clean%20minimal%20modern%20corporate%20building%2C%20bright%20neutral%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20editorial%20photography&width=900&height=640&seq=axonia-veh-006&orientation=landscape",
    estado: "disponible",
    zona: "Zona metropolitana",
    servicio: "Transporte empresarial",
    orden: 6,
    activo: true,
  },
  {
    id: "veh-007",
    nombre: "Autobús interurbano",
    categoria: "autobuses",
    tipo: "Autobús",
    capacidad: "48 pasajeros",
    capacidadGrupo: "alta",
    descripcion:
      "Autobús cómodo y seguro para giras, excursiones y traslados de grupos grandes.",
    caracteristicas: ["48 plazas", "Aire acondicionado", "Bodega amplia", "Conductor profesional"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Modern%20white%20intercity%20coach%20bus%20travelling%20on%20a%20clean%20open%20highway%20with%20clear%20sky%2C%20minimal%20background%2C%20soft%20natural%20lighting%2C%20cool%20blue%20tones%2C%20professional%20editorial%20transport%20photography%2C%20sharp%20detail&width=900&height=640&seq=axonia-veh-007&orientation=landscape",
    estado: "disponible",
    zona: "Cobertura regional",
    servicio: "Transporte para grupos",
    orden: 7,
    activo: true,
  },
  {
    id: "veh-008",
    nombre: "Minibús ejecutivo",
    categoria: "autobuses",
    tipo: "Minibús",
    capacidad: "28 pasajeros",
    capacidadGrupo: "media",
    descripcion:
      "Minibús ejecutivo para traslados corporativos, eventos y grupos medianos con máxima comodidad.",
    caracteristicas: ["28 plazas", "Interior ejecutivo", "Wi-Fi a bordo", "Conductor profesional"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Sleek%20white%20executive%20minibus%20parked%20in%20front%20of%20a%20clean%20minimal%20modern%20venue%2C%20bright%20neutral%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20palette%2C%20professional%20editorial%20photography%2C%20high%20detail&width=900&height=640&seq=axonia-veh-008&orientation=landscape",
    estado: "mantenimiento",
    zona: "Zona metropolitana",
    servicio: "Transporte empresarial",
    orden: 8,
    activo: true,
  },
  {
    id: "veh-009",
    nombre: "Vehículo para eventos y producciones",
    categoria: "eventos",
    tipo: "Unidad para eventos",
    capacidad: "3 t · Backline",
    capacidadGrupo: "media",
    descripcion:
      "Unidad equipada para transporte de producción, sonido, iluminación y montajes de eventos.",
    caracteristicas: ["Carga de producción", "Rampa de carga", "Sujeción reforzada", "Disponibilidad nocturna"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=White%20production%20van%20with%20stage%20equipment%2C%20trusses%20and%20speaker%20cases%20being%20loaded%20beside%20an%20outdoor%20event%20venue%2C%20clean%20minimal%20background%2C%20soft%20evening%20light%20with%20cool%20blue%20tint%2C%20professional%20event%20logistics%20photography&width=900&height=640&seq=axonia-veh-009&orientation=landscape",
    estado: "disponible",
    zona: "Cobertura nacional",
    servicio: "Transporte para eventos",
    orden: 9,
    activo: true,
  },
  {
    id: "veh-010",
    nombre: "Unidad especial con plataforma",
    categoria: "especiales",
    tipo: "Unidad especial",
    capacidad: "Brazo hidráulico",
    capacidadGrupo: "alta",
    descripcion:
      "Vehículo con plataforma y brazo hidráulico para cargas sobredimensionadas y montajes especiales.",
    caracteristicas: ["Brazo hidráulico", "Cargas especiales", "Operador certificado", "Permisos gestionados"],
    imagen_url:
      "https://readdy.ai/api/search-image?query=Special%20purpose%20truck%20with%20hydraulic%20boom%20lifting%20oversized%20industrial%20equipment%20in%20a%20clean%20open%20yard%2C%20minimal%20bright%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20steel%20grey%20tones%2C%20professional%20industrial%20photography&width=900&height=640&seq=axonia-veh-010&orientation=landscape",
    estado: "no_disponible",
    zona: "A cotizar",
    servicio: "Servicios especiales",
    orden: 10,
    activo: true,
  },
];